<div class="card-header">
  <span *ngIf="!addNewOfflinePayment">Existing Offline Payments</span>
  <span *ngIf="addNewOfflinePayment">Add Offline Payment</span>
  <button class="btn btn-sm btn-warning float-right" style="margin-top: -4px;font-size: 14px;background-color:  rgb(87,200,231);color: #ffffff;height:38px;" (click)="toggleDiv('new')">
    <span *ngIf="this.addNewOfflinePayment==false" tooltip="Make a new offline payment">
      <i class="fa fa-plus-circle" style="margin-top:6px;color:#fff;"></i> New Offline Payment</span>
    <span *ngIf="this.addNewOfflinePayment==true" tooltip="View offline payment(s)" (click)="getofflinePaymentObj()">
      <i class="fa fa-arrow-left" style="margin-top:6px;color:#fff;"></i> Back</span>
  </button>
</div>
<!--start : package table-->
<div class="content-body padding-top-20 padding-bottom-20" *ngIf="addNewOfflinePayment==false">
  <div class="row">
  <div class="row" style="padding: 10px 5px;">
    <form #downloadXLSForm="ngForm" novalidate >
      <div class="col-lg-3 col-xs-12 pull-right" style="padding-top:20px;">
        <button [disabled]="!downloadXLSForm.form.valid" tooltip="Export to Excel" (click)="downloadXLS()" class="btn btn-sm btn-success marginLR5 pull-right">
          <i class="fa fa-fw fa-lg fa-file-excel-o"></i></button>
        <button [disabled]="!downloadXLSForm.form.valid" tooltip="Filter by Date" (click)="getFilteredOfflinePayments()" class="btn btn-sm btn-success marginLR5 pull-right" style="margin-right : 10px;">
          <i class="fa fa-fw fa-lg fa-filter"></i></button>
          <button [disabled]="!downloadXLSForm.form.valid" tooltip="Clear date filter" (click)="clearDateFilter()" class="btn btn-sm btn-success marginLR5 pull-right" style="margin-right : 10px;">
            <i class="fa fa-fw fa-lg fa-filter"></i>Clear Filter</button>
      </div>
      <div class="col-lg-2 col-xs-12 pull-right">
        <label class="form-label" for="toDate">To</label>
        <input #amount="ngModel" name="toDate" id="toDate" type="date" [(ngModel)]="range.toDate" [max]="today" placeholder="Enter date of payment here..."
          class="form-control" required>
      </div>
      <div class="col-lg-2 col-xs-12 pull-right">
        <label class="form-label" for="fromDate">From</label>
        <input #amount="ngModel" name="fromDate" id="fromDate" type="date" [(ngModel)]="range.fromDate" [max]="today" placeholder="Enter date of payment here..."
          class="form-control" required>
      </div>
    </form>
  </div>

    <p-table 
    [value]="offlinePayments"
    [lazy]="true"
    (onLazyLoad)="onPageChange($event)"
    [paginator]="offlinePayments != null && offlinePayments.length > 0"
    [rows]="rows"
    [first]="paging.currentPage"
    [totalRecords]="totalRecords"
    #dt
      >
      <ng-template pTemplate="header">
        <tr style="height:60px;">
          <th style="width:100px;text-align: center;">#
          </th>
          <th [pSortableColumn]="'accountName'">Account
            <p-sortIcon [field]="'accountName'"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'packageName'">Package Name
            <p-sortIcon [field]="'packageName'"></p-sortIcon>
          </th>
          <th class="text-center" [pSortableColumn]="'amount'"> Amount
            <p-sortIcon [field]="'amount'"></p-sortIcon>
          </th>
          <th class="text-center" [pSortableColumn]="'mercantile'">Payment Mode
            <p-sortIcon [field]="'mercantile'"></p-sortIcon>
          </th>
          <th class="text-center" [pSortableColumn]="'transactionId'"> Transaction Id
            <p-sortIcon [field]="'transactionId'"></p-sortIcon>
          </th>
          <th class="text-center" [pSortableColumn]="'dateOfPayment'">Date of Payment 
            <p-sortIcon [field]="'dateOfPayment'"></p-sortIcon>
          </th>
          
        </tr>
        <tr   style="font-family:Arial, FontAwesome;text-align: center;" >
          <td class="primeng-table-search">
            <!-- <input class="primeng-table-search-field" disabled pInputText type="search"
              (input)="dt.filter($event.target.value, 'packageName', 'contains')"> -->
          </td>
          <td class="primeng-table-search">
            <input class="primeng-table-search-field search-bar-true" placeholder="&#xf002;  Account name" pInputText type="text"
            (input)="onSearch($event.target.value,'accountname')">
          </td>
          <td class="primeng-table-search">
            <input class="primeng-table-search-field search-bar-true" placeholder="&#xf002;  Package name" pInputText type="text"
            (input)="onSearch($event.target.value,'packagename')">
          </td>
          <td class="primeng-table-search">
            <input class="primeng-table-search-field search-bar-true" placeholder="&#xf002;  Amount" pInputText type="text"
              (input)="onSearch($event.target.value,'amount')">
          </td>
          <td class="primeng-table-search">
            <input class="primeng-table-search-field search-bar-true" placeholder="&#xf002;  Payment mode" pInputText type="text"
            (input)="onSearch($event.target.value,'paymentmode')">
          </td>
          <td class="primeng-table-search">
            <input class="primeng-table-search-field search-bar-true" placeholder="&#xf002;  Transaction id" pInputText type="text"
            (input)="onSearch($event.target.value,'transactionid')">
          </td>
          <td class="primeng-table-search">
            <input class="primeng-table-search-field search-bar-true" placeholder="&#xf002;  Date of payment" pInputText type="text"
            (input)="onSearch($event.target.value,'dateofpayment')">
          </td>
        </tr>
        <tr *ngIf="offlinePayments==null || offlinePayments.length==0"
          style="border-left: 1px solid #f4f4f4;border-right: 1px solid #f4f4f4;border-bottom: 1px solid #f4f4f4;">
          <td colspan="6">
            <div style="padding: 5px;text-align: center;">
              No record found
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-itrPackage let-i="rowIndex">
        <tr class="table-striped" style="cursor: pointer;overflow-wrap: break-word;text-align: center;">
          <td style="text-align: center;">{{i+1}}</td>
          <td >{{itrPackage.accountName}}</td>
          <td style="height: 70px;" >{{itrPackage.packageName}}</td>
          <td class="text-center">{{itrPackage.amount}}</td>
          <td class="text-center">{{itrPackage.mercantile}}</td>
          <td class="text-center">{{itrPackage.transactionId}}</td>
          <td class="text-center">{{itrPackage.dateOfPayment | date:customDateFormat}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
<!--end : package table-->
<div class="content-body padding-top-20 padding-bottom-20" *ngIf="addNewOfflinePayment==true">
  <form #offlinePaymentForm="ngForm" class="mTop30" novalidate (ngSubmit)="saveOfflinePayment()">
    <div class="row">
      
      <div class="col-lg-6 form-group">
        <label class="form-label" for="account">Select Account<span class="mandatory-symbol">*</span></label>
        <ng-select #account="ngModel" [items]="accounts" name="accounts"
            placeholder="Select account" bindLabel="accountName" [clearable]="true" [searchable]="true" bindValue="accountId" [(ngModel)]="offlinePaymentObj.accountId" required>
          </ng-select>
      </div>

      <div class="col-lg-6 form-group">
        <label class="form-label" for="package">Select Package<span class="mandatory-symbol">*</span></label>
        <ng-select #package="ngModel" [items]="packages" (change)="setAmount()" name="packages" placeholder="Select Package"
          bindLabel="pkgName" [clearable]="true" [searchable]="true" bindValue="id" [(ngModel)]="offlinePaymentObj.pkgId" required>
        </ng-select>
      </div>

      <div class="col-lg-6 form-group">
        <label class="form-label" for="transactionMode">Mode of Payment <span class="mandatory-symbol">*</span></label>
        <select #transactionMode="ngModel" name="transactionMode" id="transactionMode" [(ngModel)]="offlinePaymentObj.transactionMode" class="form-select form-select-sm" #userTitle="ngModel" id="transactionMode"
          name="transactionMode" required>
          <option value="">Select Mode of Payment</option>
          <option value="Cheque">Cheque</option>
          <option value="Upi">UPI</option>
          <option value="Neft">NEFT</option>
        </select>
      </div>

      <div class="col-lg-6 form-group">
        <label class="form-label" for="transactionId">Transaction Id <span class="mandatory-symbol">*</span></label>
        <input #transactionId="ngModel" name="transactionId" id="transactionId" type="text" [(ngModel)]="offlinePaymentObj.transactionId" placeholder="Enter transaction id here..."
        pattern="^[a-zA-Z0-9-, ]*" class="form-control" required>
          <div *ngIf="transactionId.errors && transactionId.dirty" class="danger-text">
            <div *ngIf="transactionId.errors.required">
              Transaction Id is required
            </div>
            <div *ngIf="transactionId.errors.pattern">
              Incorrect input, allowed alphanumerics and special chars (, -)
            </div>
          </div>
      </div>

      <div class="col-lg-6 form-group">
        <label class="form-label" for="dateOfPayment">Date of Payment  <span class="mandatory-symbol">*</span></label>
        <input #amount="ngModel" name="dateOfPayment" id="dateOfPayment" type="date" [(ngModel)]="offlinePaymentObj.dateOfPayment" [max]="today" placeholder="Enter date of payment here..."
          class="form-control" required>
      </div>

      <div class="col-lg-6 form-group">
        <label class="form-label" for="amount">Amount</label>
        <input #amount="ngModel" name="amount" id="amount" type="number" [(ngModel)]="offlinePaymentObj.amount" placeholder="Enter amount here..."
          class="form-control" [readonly]="true" required>
      </div>

      <div class="col-lg-6 form-group">
        <label class="form-label" for="amount">Currency</label>
        <input #currency="ngModel" name="currency" id="currency" type="text" [(ngModel)]="offlinePaymentObj.currency" placeholder="Enter currency here..."
          class="form-control" [readonly]="true" required>
      </div>
      
      <div class="col-xs-12 text-center ">
        <button [disabled]="!offlinePaymentForm.form.valid" tooltip="Save offline payment" class="btn btn-sm btn-success marginLR5">
          <i class="fa fa-fw fa-lg fa-check-circle"></i>
          Activate Offline Payment</button>
      </div>
    </div>
  </form>
</div>